const lang = {
  title: 'お問い合わせ',
  fname: 'お名前',
  name: '名前',
  errorName: '名前は有効ではありません。',
  phoneNumber: '電話番号',
  phoneNumberError: '電話番号は有効ではありません。',
  mailAddress: 'メールアドレス',
  mailAddressError: 'メールアドレスは有効ではありません。',
  content: '内容',
  contentError: '内容は有効ではありません。',
  readInfo: '個人情報の取り扱いをお読みいただき',
  checkboxMessage: '「同意する」チェックボックスにチェックを入れてください。',
  agreeCheckbox: '個人情報保護方針に同意する',
  acceptTerm: 'この内容で送信',
  acceptTermErrorMessage: '「同意する」チェックボックスにチェックを入れてください。',
  require: '※必須',
  placeholder: {
    please_enter: '入力してください',
    please_enter_no_hyphen: '入力してください（ハイフンなし）'
  },
  cl203_1: {
    faq: 'よくある質問',
    zengo_intro_page: 'ZENGO紹介ページ',
    please_check: 'にてご確認ください。',
    contact_info: 'お問い合わせ先',
    here: 'こちら',
    please_contact_us: 'からお問い合わせください。',
  },
  cl203_2: {
    content: 'LPページと合わせて<br>FAQを用意'
  },
  cl203_3: {
    handle_person_info: '個人情報保護方針',
    please_read: 'をお読みいただき',
    message_contact_success: 'お問い合わせを送信しました。'
  }

}
export default lang;



// WEBPACK FOOTER //
// ./src/lang/ja/pages/cl203.js